import React, { useEffect, useState } from 'react';
import { Loader2, UserCog } from 'lucide-react';
import { toast } from 'sonner';
import { followupsAPI, usersAPI } from '../../services/api';
import { Button } from '../ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const UNASSIGNED = '__none__';

export const BulkAssignDialog = ({ open, onOpenChange, ids, onDone }) => {
  const [directory, setDirectory] = useState([]);
  const [owner, setOwner] = useState(UNASSIGNED);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) usersAPI.directory().then((res) => setDirectory(res.data.users || [])).catch(() => {});
  }, [open]);

  const assign = async () => {
    setBusy(true);
    try {
      const response = await followupsAPI.bulkAssign({
        ids, owner_id: owner === UNASSIGNED ? null : owner,
      });
      toast.success(response.data.message);
      onOpenChange(false);
      onDone?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Bulk assignment failed');
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="bulk-assign-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserCog className="h-5 w-5 text-blue-600" /> Assign owner
          </DialogTitle>
          <DialogDescription>
            {ids.length} inquiry(s) will be handed to one person. Each change is written to the inquiry timeline.
          </DialogDescription>
        </DialogHeader>
        <div className="py-2">
          <Select value={owner} onValueChange={setOwner}>
            <SelectTrigger data-testid="bulk-assign-owner-select"><SelectValue placeholder="Choose owner" /></SelectTrigger>
            <SelectContent>
              <SelectItem value={UNASSIGNED}>Unassigned (clear owner)</SelectItem>
              {directory.map((member) => (
                <SelectItem key={member.id} value={member.id}>{member.name} · {member.role}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="bulk-assign-cancel">Cancel</Button>
          <Button onClick={assign} disabled={busy} data-testid="bulk-assign-confirm">
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <UserCog className="mr-2 h-4 w-4" />}
            Assign {ids.length}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkAssignDialog;
